/**
 * 2022-02-13
 * origin: https://app.zeplin.io/project/614bed834869303d4a4096e4/screen/61dc3caba7a65728a5d0f923
 * icon卖点组件之No.4
 */
import css from './index.module.scss';
import { TextModule, TextIconCell } from '@/components/ProductDetailComponents';
import EFBlueTick from '@/components/UI/svg/Icons/EFBlueTick';

const defaultData = {
    guide: { text: 'Interior / Exterior Design' },
    title: { text: 'Power pretty much anything' },
    desc: {
        text: 'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. ',
    },
    items: [
        {
            icon: <EFBlueTick />,
            title: 'Interior Design ',
            des: 'DELTA Pro’s capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ',
            directUrl: '/',
        },
        {
            icon: <EFBlueTick />,
            title: 'Interior Design ',
            des: 'DELTA Pro’s capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ',
            directUrl: '/',
        },
        {
            icon: <EFBlueTick />,
            title: 'Interior Design ',
            des: 'DELTA Pro’s capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ',
            directUrl: '/',
        },
    ],
};

const defaultStyle = {
    backColor: 'transparent',
    height: 'auto',
    guideStyle: {
        fontClass: 'font-family-semibold',
        fontWeight: 500,
        color: '#2673ff',
        fontSize: '32px',
        lineHeight: '40px',
        margin: '0 0 10px 0',
        width: '490px',
    },
    titleStyle: { type: 'ls', margin: '0 0 60px 0', width: '490px' },
    descStyle: {
        type: 'sl',
        fontFamily: 'var(--font-family-Medium)',
        lineHeight: '36px',
        width: '490px',
    },
    textIconStyle: {
        fontClassTitle: 'font-family-bold',
        desLineHeight: '25px',
        wrapperBackColor: '#f6f6f8',
        wrapperPadding: '40px 50px',
        wrapperWidth: '490px',
        wrapperHeight: '360px',
        wrapperBorderRadius: '20px',
        fontWeightTitle: 500,
        fontWeightDesc: 600,
    },
};

/**
 *
 * @param data {
 *  guide: 参考TextModule组件data参数,
 *  title: 参考TextModule组件data参数,
 *  desc: 参考TextModule组件data参数,
 *  items: 参考TextIconCell组件data参数,
 * }
 * @param defaultStyle{
 *  guideStyle: 参考TextModule组件cssStyle参数,
 *  titleStyle: 参考TextModule组件cssStyle参数,
 *  descStyle: 参考TextModule组件cssStyle参数,
 *  textIconStyle: 参考TextIconCell组件cssStyle参数,
 * }
 */

export default function Fourth({ data = defaultData, cssStyle = defaultStyle }: any) {
    const { guide, title, desc, items } = {
        guide: { ...defaultData.guide, ...data.guide },
        title: { ...defaultData.title, ...data.title },
        desc: { ...defaultData.desc, ...data.desc },
        items: data.items,
    };
    cssStyle.backColor = cssStyle.backColor ?? defaultStyle.backColor;
    cssStyle.height = cssStyle.height ?? defaultStyle.height;
    cssStyle.guideStyle = {
        ...defaultStyle.guideStyle,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.guideStyle,
    };
    cssStyle.titleStyle = {
        ...defaultStyle.titleStyle,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.titleStyle,
    };
    cssStyle.descStyle = {
        ...defaultStyle.descStyle,
        ...{ backColor: cssStyle.backColor },
        ...cssStyle.descStyle,
    };
    cssStyle.textIconStyle = {
        ...defaultStyle.textIconStyle,
        ...{ wrapperBackColor: cssStyle.backColor },
        ...cssStyle.textIconStyle,
    };
    const { backColor, height, guideStyle, titleStyle, descStyle, textIconStyle } = cssStyle;
    const isWhiteTheme = backColor === '#fff' || backColor === '#ffffff' || backColor === 'transparent';

    return (
        <div className={`${css.sellPointsModule} sellPointsModuleFourth`} style={{ background: backColor, height: height }}>
            <div className="container">
                <div className="leftPart">
                    <TextModule cssStyle={guideStyle} data={guide} />
                    <TextModule cssStyle={titleStyle} data={title} />
                    <TextModule cssStyle={descStyle} data={desc} />
                </div>
                <div className="rightPart">
                    <ul className="sellLists" style={{ maxHeight: height }}>
                        {items?.map((item: any, i: number) => (
                            <li className="list" key={i}>
                                <TextIconCell cssStyle={textIconStyle} data={item} />
                            </li>
                        ))}
                    </ul>
                    <div className={isWhiteTheme ? 'cover' : 'cover coverBlack'}></div>
                </div>
            </div>
        </div>
    );
}
